<template>
  <modal
    bodyClasses="text-center mt-4"
    :show.sync="$parent.modals.logoutRefreshModal"
    @close="closeModal"
  >
    <i class="fas fa-exclamation-triangle text-warning"></i>
    <h2 class="mt-4">An update is available!</h2>
    <p class="text-center">
      We've made a few changes. Please click the button below to{{
        isLoggedIn ? " log out and " : " "
      }}update the application.
    </p>
    <p class="text-center mb-0">
      <small>Not updating may result in errors.</small>
    </p>

    <base-button type="primary" @click="closeModal" class="mt-4" block>{{
      isLoggedIn ? "LOGOUT" : "UPDATE"
    }}</base-button>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import { logoutRefreshMixin } from "@/components/mixins/logout-refresh.mixin";

export default {
  name: "logout-refresh-modal",
  mixins: [logoutRefreshMixin],
  methods: {
    closeModal() {
      // Close modal and reload
      this.reloadApp();
      this.$parent.modals.logoutRefreshModal = false;
    }
  },
  computed: {
    ...mapState["isLoggedIn"]
  }
};
</script>

<style scoped lang="scss">
.fa-exclamation-triangle {
  font-size: 3rem;
}
</style>
